export default __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu4mxK.woff2";